export const InvestmentUploadConfig = {
	list: 'Investment',
	grid: {
		gridId: 'InvestmentUploadGrid',
		height: 500,
		checkbox: false,
		edit: false,
		delete: true,
		pageSize: 10,
		groupable: false
	},
	columns: {
		InvestmentKey: {
			dataName: 'InvestmentKey',
			type: 'string',
			title: 'InvestmentKey',
			width: 100,
			hidden: true
		},
		Validation: {
			dataName: 'Validation',
			type: 'string',
			title: 'Validation',
			width: 130,
			hidden: false
		},
		Title: {
			class: 'value',
			dataName: 'Title',
			type: 'string',
			title: 'Investment Name',
			width: 150,
			hidden: false,
		},
		InvestmentGroup: {
			class: 'choice',
			dataName: 'InvestmentGroup',
			type: 'string',
			title: 'Investment Group',
			width: 220,
			hidden: false,
		},
		StatementOrder: {
			class: 'value',
			dataName: 'StatementOrder',
			type: 'number',
			title: 'Statement Order',
			width: 140,
			hidden: false,
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: false,
		},
		ShowOnFMVS: {
			class: 'choice',
			dataName: 'ShowOnFMVS',
			type: 'string',
			title: 'Show on FMVS',
			width: 100,
			hidden: false,
			readOnly: false
		},

	}
}